/**
 * @typedef {import('./lib/index.js').GetDefinition} GetDefinition
 */

export {definitions} from './lib/index.js'
